<script setup>
import InputLabel from "@/Components/InputLabel.vue";
import {computed} from "vue";
import {trans} from "laravel-vue-i18n";

const props = defineProps({
    modelValue: Boolean | Object | Number | null | undefined,
    title: String,
    disabled: Boolean,
    items: Array | undefined,
    titleField: String | undefined,
    hasError: Boolean | undefined,
});
const emit = defineEmits(['update:model-value']);
const isBoolean = computed(() => {
    return props.items === undefined;
});
// console.log(isBoolean.value)
const values = computed(() => {
    return isBoolean.value ? [
        {
            value: true,
            title: trans('Yes')
        },
        {
            value: false,
            title: trans('No')
        },
    ] : props.items;
});
// console.log(values.value)
// console.log(props.modelValue)
</script>

<template>
    <div class="flex justify-between py-2.5">
        <InputLabel :class="{'text-red-500': hasError}" :value="title"
                    class="font-sans font-medium text-black dark:text-slate-200 flex items-center uppercase"
        />
        <div>
            <button v-for="(item, index) in values" :key="index"
                    :class="{'bg-blue-600 !border-blue-600 text-white font-semibold': isBoolean ? item.value === Boolean(modelValue) : modelValue === item.id}"
                    :disabled="disabled"
                    :value="index"
                    class="font-normal text-slate-500 dark:text-slate-400  border-slate-300 dark:border-slate-700 text-sm px-3 py-1 rounded-full mr-3 border last:mr-0 hover:border-blue-300 transition-colors"
                    @click="emit('update:model-value', isBoolean ? item.value : item.id)">
                {{ titleField ? item[titleField] : item.title }}
            </button>
        </div>
    </div>
</template>

<style scoped>

</style>
